import EventBus from 'event_bus'
import { updateRegistrationTeasers } from '../registration_teaser'

export default class BookmarkRemove {
  constructor ($el) {
    this.onBookmarkRemoved = this.onBookmarkRemoved.bind(this)
    this.onBookmarkAdded = this.onBookmarkAdded.bind(this)
    this.remove = this.remove.bind(this)
    this.$el = $el
    this.jobId = parseInt(this.$el.data('jobId'))
    this.title = this.$el.data('title')
    this.skipAnimation = this.$el.data('skip-animation')
    this.addEventListeners()
  }

  addEventListeners () {
    if (!this.skipAnimation) {
      EventBus.on('bookmarks:removed', this.onBookmarkRemoved)
    }

    EventBus.on('bookmarks:added', this.onBookmarkAdded)
    this.$el.on('click', ((_this) => {
      return (e) => {
        e.preventDefault()
        _this.remove(_this.jobId)
      }
    })(this))
  }

  removeEventListeners () {
    EventBus.off('bookmarks:removed', this.onBookmarkRemoved)
    EventBus.off('bookmarks:added', this.onBookmarkAdded)
  }

  onBookmarkAdded (_event, jobId) {
    if (jobId === this.jobId) {
      return this.$el.addClass('bookmark-flag__toggle-label--active')
    }
  }

  onBookmarkRemoved (_event, jobId) {
    if (jobId === this.jobId) {
      return this.$el.removeClass('bookmark-flag__toggle-label--active')
    }
  }

  onUndo (_event) {
    EventBus.trigger('bookmarks:add', this.jobId)
  }

  remove (jobId) {
    $.ajax({
      url: this.$el.data('url'),
      data: {
        title: this.title,
        refresh_registration_teasers: $('.js-dynamic-registration-teaser').length > 0
      },
      method: 'delete',
      dataType: 'json'
    }).done((data) => {
      updateRegistrationTeasers(data.teaser)
      EventBus.trigger('bookmarks:removed', jobId)
      EventBus.trigger('snackbar:message', {
        body: data.snackbar,
        handlers: [{
          selector: '.js-snackbar__button',
          eventName: 'click',
          handler: this.onUndo.bind(this)
        }]
      })
    })
  }
}
